export var Paths;

(function (Paths) {
  Paths["Show"] = "/me/profile";
  Paths["Update"] = "/me/profile";
  Paths["UpdateImage"] = "/me/profile/image";
  Paths["UpdatePin"] = "/me/pin";
  Paths["SendPinReset"] = "/me/send_pin_reset";
  Paths["ResetPin"] = "/me/pin_reset";
})(Paths || (Paths = {}));